import hipLogo from "@/hip-3.png";
import { cn } from "@/lib/utils";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Overview" },
  { to: "/leaderboards", label: "Leaderboards" },
  { to: "/markets", label: "Markets" },
  { to: "/providers", label: "Providers" },
];

export function PageShell({ children }: { children: React.ReactNode }) {
  const year = new Date().getFullYear();

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-border/80 bg-background/95">
        <div className="mx-auto flex w-full max-w-none items-center justify-between gap-4 px-4 py-2.5 md:px-6 2xl:px-10 min-[1680px]:max-w-400">
          <Link to="/" className="flex items-center gap-2">
            <img src={hipLogo} alt="HIP-3" className="h-6 w-6" />
            <div>
              <div className="text-sm font-bold tracking-wide uppercase">hip3.market</div>
              <div className="text-[10px] font-mono uppercase tracking-wide text-muted-foreground">Ecosystem dashboard</div>
            </div>
          </Link>

          <div className="hidden items-center gap-3 md:flex">
            <nav className="flex items-center gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    cn(
                      "border border-transparent px-2.5 py-1 text-xs font-mono uppercase tracking-wide text-muted-foreground transition hover:text-foreground",
                      isActive && "border-primary/35 bg-primary/10 text-primary"
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>

            <a
              href="https://degenhouse.sh"
              target="_blank"
              rel="noreferrer"
              className="hidden border-l border-border/80 pl-3 text-[10px] font-mono uppercase tracking-wide text-muted-foreground transition hover:text-foreground lg:inline"
            >
              Built by DegenHouse
            </a>
          </div>
        </div>

        <nav className="mx-auto flex w-full max-w-none gap-1 overflow-x-auto px-4 pb-2 md:hidden 2xl:px-10 min-[1680px]:max-w-400">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                cn(
                  "whitespace-nowrap border border-border/70 px-2.5 py-1 text-[0.68rem] font-mono uppercase tracking-wide text-muted-foreground",
                  isActive && "border-primary/45 bg-primary/10 text-primary"
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto w-full max-w-none flex-1 px-4 py-5 md:px-6 md:py-6 2xl:px-10 min-[1680px]:max-w-400">
        {children}
      </main>

      <footer className="border-t border-border/80">
        <div className="mx-auto flex w-full max-w-none items-center justify-between gap-3 px-4 py-2 md:px-6 2xl:px-10 min-[1680px]:max-w-400">
          <div className="text-[0.62rem] font-mono uppercase tracking-wide text-muted-foreground">
            © {year} hip3.market
          </div>
          <div className="text-[0.62rem] font-mono uppercase tracking-wide text-muted-foreground">
            Data-driven HIP-3 explorer
          </div>
        </div>
      </footer>
    </div>
  );
}
